import useAuth from './useAuth';

/**
 * Returns true if the current user has the given permission code.
 *
 * Usage:
 *   const canViewBilling = usePermission('billing.view');
 *   const canManageRoles = usePermission('roles.manage');
 *
 * Always returns false for non-org users or unauthenticated sessions.
 */
export default function usePermission(code) {
  const { hasPermission } = useAuth();
  return hasPermission(code);
}
